export default __webpack_public_path__ + "static/media/right-arrow.b21fb42d.svg";